

<script>
import baseList from "@/views/components/base/baseList2.vue";
export default {
  extends: baseList,
  components: {
    Image,
  },
  data() {
    return {
      flag:false,
      model:[],
      orderstype: "订单管理",
      table: {
        mname: "ordersType",
        key: "id",
        url: {
          del: "/admin/ordersType/delete",
          export: `/admin/ordersType/export`,
        },
        output: false,
        order: 'id',
        qrCode: "qrCode",
      },
      logistics:[],
      currentRow:{},

      tactions: [
        {
          label: "待发货",
          type: "info",
          onClick: this.orderStatueSelect,
          auth: "/admin/ordersType/list",
          count:0,
          status:1
        },
        {
          label: "已发货",
          type: "info",
          onClick:  this.orderStatueSelect,
          auth: "/admin/ordersType/list",
          count:0,
          status:2
        },
        {
          label: "已签收",
          type: "info",
          onClick: this.orderStatueSelect,
          auth: "/admin/ordersType/list",
          count:0,
          status:3
        },
      ],
      actions: [
        {
          label: "昨天",
          onClick: this.orderTimeSelect,
          auth: "/admin/ordersType/list",
          time:-1,
          type: "info",
        },
        {
          label: "今天",
          type: "info",
          onClick:  this.orderTimeSelect,
          auth: "/admin/ordersType/list",
          time:0,
        },
        {
          label: "近七天",
          type: "info",
          onClick: this.orderTimeSelect,
          auth: "/admin/ordersType/list",
          time:-6
        },
      ],
      filters: [{ label: '订单编号',KeyEnter:this.search,name: 'orderNumber', value: '', type: 'input' }],
      menus: [

      ],
      tableCols: [
        {
          align: 'center',
          title: '订单编号',
          key: 'orderNumber',
        },
        {
          title: '订单状态',
          width: 110,
          align: 'center',
          render: (h, p) => {
            const status = p.row.orderStatus
            if (status == 1) {
              return <p style="color: skyblue">待发货</p>
            } else if (status == 2) {
              return <p style="color: red">已发货</p>
            } else if (status == 3) {
              return <p style="color: green">已签收</p>
            }
          },
        }, {
          title: '商品合计',
          width: 110,
          align: 'center',
          render: (h, p) => {
            return (
                <p>共{p.row.commodityCount}个</p>
            )
          }
        }, {
          title: '客户名称',
          key: 'customerName',
          align: 'center',
          width: 200,
        }, {
          title: '创建时间',
          key: 'createTime',
          width: 200,
          align: 'center',
        }, {
          title: '操作',
          align: 'center',
          width: 200,
          key: "handle",
          handle: [
            (vm, h, currentRow, param) => {
              if (currentRow.orderStatus > 1) {
                return (
                  <Button disabled>
                    已发货
                  </Button>
                )
              } else {
                return (
                  <Button
                    onClick={() => this.show(currentRow)}
                    type="default"
                    style={{
                          border:"none",
                          color: "#4991ff",}}>发货
                  </Button>
                );
              }

            },
            (vm, h, currentRow, param) => {
              {
                return (
                    <Button
                        onClick={() => this.selectOrder(currentRow)}
                        style="margin-left:5px"
                        type="default"
                        style={{
                              border:"none",
                              color: "#4991ff",}}>详情
                    </Button>
                );
              }

            },
          ]

        },
      ],
      orderLength:0,
      saledLength:0
    };
  },
  async created() {
    let a = await $utils.api.load(`/admin/logisticsType/list`);
    this.logistics = a.rows
    this.orderLengthSelect();
  },
  methods: {
    selectOrder(row){
      $utils.url.push({ name: "ordersType_add", query: { action: "add",kv:row.id } });
    },
    show(e){
      this.flag =!this.flag;
      this.currentRow =e
    },

    async ok(){
      this.currentRow.orderStatus = this.currentRow.orderStatus + 1
      let p = {}
      p.id = this.currentRow.id
      p.orderStatus = this.currentRow.orderStatus
      p.logisticsId = this.model
        try{
            let res = await $utils.api.load(`/admin/ordersType/update`, p, 'get')
            if (res.status) {
                $utils.toast.success('保存成功')
            }
          }catch(e){
            $utils.toast.error('保存异常' + e.message)
          }
    },
    // 搜索订单数量
    async orderLengthSelect() {
      let res = await $utils.api.load(`/admin/ordersType/count`,{},"get")
      try {
        this.title =
            "订单数量:" +
            res.data.count +
            "\xa0\xa0\xa0\xa0\xa0\xa0\xa0" +
            "已售商品:" +
            res.data.total;
      }catch (e){
        console.log(e)
      }
    },
   
   
   
    // 搜索订单时间
    async orderTimeSelect(AddDayCount) {
      let dd = new Date();
      dd.setDate(dd.getDate()+AddDayCount);//获取AddDayCount天后的日期
        let year = dd.getFullYear(); //得到年份
        let month = dd.getMonth()+1;//得到月份
        let date = dd.getDate();//得到日期
        let hour = dd.getHours();//得到小时
        let minu = dd.getMinutes();//得到分钟
        let sec = dd.getSeconds();//得到秒
        let time = year + "-" + month + "-" + date + " " + hour + ":" + minu + ":" + sec ;
        let a = {}
        a.createTime = time
        try {
           let res = await $utils.api.load(`/admin/ordersType/list`, a, 'get')
           this.$refs.tablelist.thisTableData = res.rows
        } catch (error) {
          $utils.toast.error(error)
        }
    },
    // 搜索订单状态
    async orderStatueSelect(status) {
      let a = {}
      a.orderStatus = status
        try {
            let res = await $utils.api.load(`/admin/ordersType/list`, a, 'get')
            this.$refs.tablelist.thisTableData = res.rows
        } catch (error) {
          $utils.toast.error(error)
        }
    },
  },
};

</script>

